module.exports = __webpack_public_path__ + "img/keyichugong.e30db2c1.png";